module.exports = __webpack_public_path__ + "static/media/iconCoursesf.3261dc26.svg";